import { RestClient } from "./restClient";

export class EventLookupsService {
	constructor(options) {
		this._options = options;
		this._restClient = new RestClient();
	}

	getAll(callback) {
		const url = "/ecosystem/api/eventLookups";
		// If gets passed a callback, executes normally. Otherwise returns promise for use with async/await, etc.
		if (callback) {
			this._restClient.exec_get(url, callback);
		} else {
			return new Promise((resolve, reject) => {
				this._restClient.exec_get(url, (err, result) => {
					if (err) {
						reject(err);
						return;
					}
					resolve(result);
				});
			});
		}
	}

	//bulkSave
	bulkSaveEventLookups(data, callback) {
		const url = "/ecosystem/api/eventLookups/bulkSave";
		const body = JSON.stringify(data);
		this._restClient.exec_put(url, body, callback);
	}
}
